import NetxQueryClient, {
	SuccessResponse,
} from '@netx/core-next/lib/queryClient';
export type {QueryError} from '@netx/core-next/lib/queryClient';

/**
 * `changePassword` request params
 * (what is used to send to server)
 */
export type ChangePasswordRequestOptions = {
	login: string;
	resetUrl?: string;
} & (
	| {
			token: string;
			password: string;
	  }
	| {
			token?: undefined;
			password?: undefined;
	  }
);

/**
 * `changePassword` request
 * (what gets sent to the server)
 */
export type ChangePasswordRequest = [
	string, // login
	string, // reset url
	string, // token
	string, // new password
];

/**
 * `changePassword` response
 * (what comes back from the server)
 */
export type ChangePasswordResponse = SuccessResponse<ChangePasswordResult>;

/**
 * `changePassword` result
 * (what is utilized from the server response)
 */
export type ChangePasswordResult = boolean;

export const changePasswordEndpoint = 'changePassword';

/**
 * ChangePassword user
 * @param fetchParams Fetch params
 * @returns Session key
 */
export const changePassword = async ({
	login,
	resetUrl,
	token,
	password,
}: ChangePasswordRequestOptions) => {
	const client = NetxQueryClient();

	const _resetUrl = token
		? ''
		: resetUrl || `${window.location.href.replace(/#.*$/, '')}#password-reset`;

	const requestParams: ChangePasswordRequest = [
		login,
		_resetUrl,
		token || '',
		password || '',
	];

	return client
		.post<ChangePasswordResponse>(changePasswordEndpoint, requestParams)
		.then((response) => {
			if (!response.data.result) throw new Error('Unable to reset password');

			return response.data.result;
		});
};
export default changePassword;
